import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Loader2, CheckCircle2 } from 'lucide-react';

const VerifyMagicLinkPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying');
  const { verifyMagicLink } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (!token) {
      toast.error('Invalid magic link');
      navigate('/login');
      return;
    }

    const verify = async () => {
      try {
        await verifyMagicLink(token);
        setStatus('success');
        toast.success('Login successful!');
        setTimeout(() => {
          navigate('/client/dashboard');
        }, 1500);
      } catch (error) {
        console.error('Magic link verification error:', error);
        setStatus('error');
        toast.error(error.response?.data?.detail || 'Verification failed');
        setTimeout(() => {
          navigate('/login');
        }, 2000);
      }
    };

    verify();
  }, [searchParams, verifyMagicLink, navigate]);

  return (
    <div className="min-h-screen bg-[#030712] flex items-center justify-center px-6" data-testid="verify-magic-link-page">
      <div className="text-center">
        {status === 'verifying' && (
          <>
            <Loader2 className="w-16 h-16 text-indigo-500 animate-spin mx-auto mb-4" data-testid="loading-spinner" />
            <h2 className="text-2xl font-bold font-['Syne'] text-white mb-2">Verifying...</h2>
            <p className="text-slate-400">Please wait while we log you in</p>
          </>
        )}
        
        {status === 'success' && (
          <>
            <CheckCircle2 className="w-16 h-16 text-green-500 mx-auto mb-4" data-testid="success-icon" />
            <h2 className="text-2xl font-bold font-['Syne'] text-white mb-2">Success!</h2>
            <p className="text-slate-400">Redirecting to your dashboard...</p>
          </>
        )}
        
        {status === 'error' && (
          <>
            <div className="w-16 h-16 rounded-full bg-red-500/10 flex items-center justify-center mx-auto mb-4">
              <span className="text-3xl">✕</span>
            </div>
            <h2 className="text-2xl font-bold font-['Syne'] text-white mb-2">Verification Failed</h2>
            <p className="text-slate-400">Redirecting to login...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyMagicLinkPage;
